import { render, staticRenderFns } from "./GiftCardDialog.vue?vue&type=template&id=62221f8a&scoped=true"
import script from "./GiftCardDialog.vue?vue&type=script&lang=js"
export * from "./GiftCardDialog.vue?vue&type=script&lang=js"
import style0 from "./GiftCardDialog.vue?vue&type=style&index=0&id=62221f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62221f8a",
  null
  
)

export default component.exports